module.exports = __webpack_public_path__ + "static/media/vaishnavi.dac74f73.jpeg";